<template>
    <div class="about__section">
        <h3>{{ l('ABOUT.BRANCH_HEADING') }}</h3>
        <dl>
            <template v-if="orderBranch">
                <dt>{{ l('ABOUT.ORDER_BRANCH') }}</dt>
                <dd>{{ orderBranch.name }} ({{ orderBranch.ID }})</dd>
            </template>

            <template v-if="itemBranch">
                <dt>{{ l('ABOUT.ITEM_BRANCH') }}</dt>
                <dd>{{ itemBranch.name }} ({{ itemBranch.ID }})</dd>
            </template>
        </dl>
    </div>
</template>

<script>
import { cloneDeep } from '@/functions/clone';
import { container } from '@/container';

export default {
    name: 'AboutBranchSection',

    data() {
        return {
            orderBranch: null,
            itemBranch: null,
        };
    },

    created() {
        // Clone the branches in case Vue's reactivity messes up the User object.
        this.orderBranch = cloneDeep(container.userService.currentBranch);
        this.itemBranch = cloneDeep(container.userService.currentItemBranch);
    },
};
</script>
